import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import Label from '../../../../app/common/components/Label';
import { TranslationHelpers } from '../../../../i18n/translationHelpers';
import { FONT_FAMILY, COLORS } from '../../../../app/common/constants/styles';

export interface ICardNumberInputFieldProps {
    children?: React.ReactNode;
    id: string;
    labelMessage: FormattedMessage.MessageDescriptor | string;
    value?: string;
    required: boolean;
    className?: string;
}

const CardNumberWrapper = styled.div`
    background-color: transparent;
    box-sizing: border-box;
    border: 1px solid ${COLORS.dark1};
    border-radius: 0.32rem;
    border-color: #dfdfdf;
    color: #dfdfdf;
    display: block;
    ${FONT_FAMILY.multipleRegularCss}
    font-weight: 300;
    width: 100%;
    min-height: 2.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 1.5;
    padding: 0 0.625rem;
    & + label {
        color: ${COLORS.grey7};
    }
`;

const CardNumberTitle = styled.span`
    margin-right: 10px;
`;

const CardNumberValue = styled.span``;

const FieldGroup = styled.div`
    position: relative;

    & > label {
        color: ${COLORS.grey7};
    }
`;

const CardNumberInputField = ({
    children = null,
    labelMessage,
    id,
    required,
    value,
    className,
}: ICardNumberInputFieldProps) => {
    return (
        <FieldGroup className={className} data-qaId={`qa-cardnumber-${id}`}>
            {labelMessage && (
                <Label
                    fixed={Boolean(value)}
                    labelMessage={labelMessage}
                    required={required}
                    id={id}
                />
            )}
            <CardNumberWrapper aria-labelledby={id} tabIndex={0}>
                <span>
                    <CardNumberTitle>
                        {TranslationHelpers.getFormattedMessage('payment.card_number')}
                    </CardNumberTitle>
                    <CardNumberValue>{value}</CardNumberValue>
                </span>
                {children}
            </CardNumberWrapper>
        </FieldGroup>
    );
};

export default CardNumberInputField;
